<template>
  <one-column-layout :loading="false">

    <title-bar title="EDIT ROLES" slot="titleBar">
      <div class="smd-spacer"/>

      <smd-btn icon="smd-icon-action-close" @click="close"/>
    </title-bar>

    <two-column-layout class="sb-min-180 hide-sidebar">
      <title-bar class="space-s-l" type="page" slot="sidebar">
        <smd-btn clean class="icon-text" @click="back">
          <i class="smd-icon-arrow-left"/>
          <label dark-normal>Back</label>
        </smd-btn>
      </title-bar>


      <div class="flex-center" slot="content">

        <one-column-layout class="space-l max-1000">
          <title-bar title="User Information" type="page" slot="titleBar">
            <div class="smd-spacer"/>
            <smd-btn @click.prevent="saveUserRole">Save</smd-btn>
          </title-bar>

          <div class="form new-patient">
            <table>
              <tr>
                <th>Roles</th>
                <th v-for="feature in features" :key="feature.feature">
                  {{feature.label}}
                </th>
              </tr>
              <tr v-for="role in roleNames" :key="role.name">
                <td>{{role.label}}</td>
                <td v-if="rolePermissions" v-for="feature in features" >
                  <smd-checkbox :id="feature.feature" v-model="rolePermissions[role.name]" />
                </td>
              </tr>
            </table>
          </div>

        </one-column-layout>
      </div>
    </two-column-layout>

  </one-column-layout>
</template>

<script>
  import keyBy from 'lodash/keyBy'
  import {mapActions, mapGetters} from 'vuex'
  import {
    ACTION_LOAD_FEATURES,
    ACTION_LOAD_ROLES_NAMES,
    ACTION_LOAD_ROLES,
    ACTION_UPDATE_ROLES,
    GETTER_FEATURES,
    GETTER_ROLE_NAMES,
    GETTER_ROLES
  } from '../../../store/modules/admin'

  import Routes from '../../../router/route-constants'

  export default {
    data(){
      return {
        rolePermissions: null
      }
    },
    computed: {
      ...mapGetters({
        features  : GETTER_FEATURES,
        roleNames : GETTER_ROLE_NAMES,
        roles     : GETTER_ROLES
      })
    },
    methods:{
      ...mapActions({
        loadFeatures  : ACTION_LOAD_FEATURES,
        loadRoleNames : ACTION_LOAD_ROLES_NAMES,
        loadRoles     : ACTION_LOAD_ROLES,
        updateRoles   : ACTION_UPDATE_ROLES
      }),
      back(){
        this.$router.push({name: Routes.ROUTE_ROLES});
      },
      close(){
        this.$router.push({name: Routes.ROUTE_ROLES});
      },
      afterSave(){
        this.close()
      },
      initializeData(){
        this.rolePermissions = this.roles.reduce((acc, obj) => {
          acc[obj.roleName] = keyBy(obj.rolePermissions);
          return acc;
        }, {});
      },
      saveUserRole(){
        let payload = [];
        const permissions = this.rolePermissions;
        this.roles.forEach((role)=>{
          const tempDate = {
            _id: role._id,
            rolePermissions: Object.keys(permissions[role.roleName])
          };
          payload.push(tempDate)
        });
        this.updateRoles(payload).then(()=>{
          this.close()
        })
      }
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        vm.loadFeatures();
        vm.loadRoleNames();
        vm.loadRoles().then(()=>{
          vm.initializeData();
        });
      });
    }
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .form.new-patient{
    @include make-grid-cols(150px 1fr, space(m));

    & > div:first-child{
      @extend %flex-col, %align-items-center;
    }

    .form__row--x{
      max-width: 80%;
    }
  }

</style>
